export const nullItem = (card_id, review) => {
  return {
      review: review,
      card_id: card_id,
      showed_time: 0,
      flipped_time: 0,
      submitted_time: 0,

      was_flipped: false,
      delta_t: 0,
      delta_r: 0,
      visible_time: 0,

      last_correct: false,
      was_correct: false,
      correct: 0,
      incorrect: 0,
      is_new: true,
      reverse_required: false,
      
      last_ten: 0,
      front_prob: 0,
      back_prob: 0,

  }
}
export const serialize = (historyElement) => {
  /*
   *         'card_id': card.card_id,
        'submitted_time': Date.now(),
        'showed_time': showedTime,
        'review': review,
        'was_flipped': flipped,
        'delta_t': nth > 0 && Date.now() - history[card.card_id][nth - 1].submitted_time || 0,
        'delta_r': nth > 0 && review - history[card.card_id][nth - 1].review || 0,
        'visible_time': Date.now() - showedTime,
        */
  return [
    historyElement.review, 
    historyElement.card_id, 
    historyElement.showed_time,
    historyElement.flipped_time,
    historyElement.submitted_time,
    
    historyElement.was_flipped,
    historyElement.delta_t,
    historyElement.delta_r,
    historyElement.visible_time,
    
    historyElement.last_correct,
    historyElement.was_correct,
    historyElement.correct,
    historyElement.incorrect,

    historyElement.is_new,
    historyElement.model_version,
    historyElement.p_correct,

    !!historyElement.side_shown,
    !!historyElement.both_sides_mode,
    historyElement.reverse_required,
    historyElement.selection_mode
  ]
}

export const deserialize = (historyRow ) => {
  const rowLength = historyRow.length;
  const hasFlippedTime = rowLength >= 18;
  const hasReverseRequired = rowLength >= 19;
  const hasSelectionMode = rowLength >= 20;
  return {
    'review': historyRow[0],
    'card_id': historyRow[1],
    'showed_time': historyRow[2],
    'flipped_time': hasFlippedTime ? historyRow[3] : null,
    'submitted_time': hasFlippedTime ? historyRow[4] : historyRow[3],
    // double not ( !! ) converts to boolean

    'was_flipped': !! historyRow[hasFlippedTime ? 5 : 4],
    'delta_t': historyRow[hasFlippedTime ? 6 : 5],
    'delta_r': historyRow[hasFlippedTime ? 7 : 6],
    'visible_time': historyRow[hasFlippedTime ? 8 : 7],
    
    'last_correct': !! historyRow[hasFlippedTime ? 9 : 8],
    'was_correct': !! historyRow[hasFlippedTime ? 10 : 9],
    'correct': historyRow[hasFlippedTime ? 11 : 10],
    'incorrect': historyRow[hasFlippedTime ? 12 : 11],

    'is_new': !! historyRow[hasFlippedTime ? 13 : 12],
    
    'model_version': historyRow[hasFlippedTime ? 14 : 13],
    'p_correct': historyRow[hasFlippedTime ? 15 : 14],  
    'side_shown': historyRow[hasFlippedTime ? 16 : 15],
    'both_sides_mode': historyRow[hasFlippedTime ? 17 : 16],
    'reverse_required': hasReverseRequired ? !!historyRow[18] : false,
    'selection_mode': hasSelectionMode ? historyRow[19] : null
  }
}
